import * as React from "react";
import Svg, { G, Mask, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={415}
      height={362}
      viewBox="0 0 415 362"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1_1838)">
        <Mask
          id="a"
          style={{
            maskType: "alpha",
          }}
          maskUnits="userSpaceOnUse"
          x={214}
          y={37}
          width={193}
          height={169}
        >
          <Path
            d="M334.906 205.518h-.008c-26.457-.001-52.708-5.255-67.148-9.755-34.169-10.645-51.645-38.79-53.428-86.042-.829-21.962 6.664-38.925 22.271-50.419 12.919-9.514 29.148-13.85 43.318-16.838 15.718-3.313 30.18-4.993 42.985-4.993 23.091 0 41.577 5.45 54.945 16.198 10.999 8.843 16.687 19.755 20.412 28.275 4.746 10.849 7.904 28.189 8.243 45.255.295 14.873-1.344 36.56-10.828 55.413-9.523 18.93-38.298 22.906-60.762 22.906z"
            fill="#000"
          />
        </Mask>
        <G mask="url(#a)">
          <Path
            d="M364.283 66.25c-4.461-12.328-13.451-22.283-32.781-17.58-7.793 1.898-14.048 7.616-18.098 15.012-1.48 2.702-1.342 14.977.382 17.486l1.988 2.927c-1.044 4.21 3.645 14.69 4.228 21.326.988 11.246-5.658 1.34-10.589 14.598-6.415 17.251 16.653 16.37 16.653 16.37l5.663 14.192 8.806 14.216 19.825 12.723c41.437 8.014 29.671-43.812 29.671-43.812 10.723-4.377 6.428-26.284-6.048-32.515-5.077-2.535-9.189-6.652-11.164-11.971l-8.536-22.972z"
            fill="#18293D"
          />
          <Path
            d="M346.009 77.106c.124.387.517.582.876.427 1.496-.65 5.224-1.758 7.178 2.225 1.976 4.026-3.28 7.153-5.505 8.26-.643.32-1.142.896-1.405 1.603-.812 2.176-1.242 29.054-3.137 36.24-4.658 17.67 10.167.25 10.167.25s-18.283 53.875-31.404 53.933c-5.997.026-1.659-53.835-4.397-54.523 0 0 8.779-20.265 7.661-25.666-.024-.118-13.449 2.078-12.912-17.52-.612-16.752 10.272-19.757 13.062-20.383 2.353-.527 13.695-4.101 19.816 15.154z"
            fill="#E87C76"
          />
          <Path
            d="M325.77 99.886s1.404.018 4.865-.262c.816-.066 2.37-.352 3.839-.87.828-.292 1.479.743.86 1.366 0 0-2.494 2.724-5.519 2.847-2.373.093-2.848-1.11-4.045-3.081z"
            fill="#18293D"
          />
          <Path
            d="M352.133 81.879s-1.542-5.8-5.68 1.016l5.68-1.016z"
            fill="#C95B60"
          />
          <Path
            d="M328.141 81.798a4.28 4.28 0 00-2.402 5.558 4.28 4.28 0 005.558 2.403 4.281 4.281 0 10-3.156-7.961z"
            fill="#E66568"
          />
          <Path
            d="M318.231 81.726l.863 4.695-2.479-.04a.603.603 0 01-.514-.9l2.13-3.755z"
            fill="#C95B60"
          />
          <Path
            d="M324.593 75.455c.812.657-.588-2.047-1.773-2.286-1.185-.24-2.312.398-2.519 1.42 0 0 2.268-.77 4.292.866zM313.464 74.803c1.16-.337 2.411.21 2.702 1.213 0 0-1.428-.174-3.044.545M321.958 81.99c.017 1.065-.469 1.526-.985 1.535-.516.008-.87-.44-.887-1.505-.016-1.066.388-1.937.904-1.945.518-.009.951.849.968 1.914zM316.273 82.043c.017 1.018-.398 1.546-.892 1.554-.495.008-.879-.507-.896-1.525-.017-1.018.37-1.85.865-1.859.493-.01.907.812.923 1.83z"
            fill="#18293D"
          />
          <Path
            d="M315.264 87.969s.573 3.53 1.969 3.606c2.506.135 4.821-3.727 4.821-3.727l-6.79.12z"
            fill="#fff"
          />
          <Path
            d="M330.993 57.554c-1.109-1.724-4.701-1.848-13.317 2.084 0 0-3.911 12.77 5.087 10.522 1.585-.397 3.013-1.185 4.224-2.239 2.842 5.348 9.587 14.806 19.898 9.61 11.321-5.703-5.155-22.906-15.892-19.977z"
            fill="#18293D"
          />
          <Path
            d="M244.11 162.14c24.713 46.632 48.459 44.382 48.459 44.382 19.786-16.106 33.559-55.219 33.559-55.219s13.416-25.152-7.662-31.502c-10.272-1.636-29.108 48.14-34.254 55.026l-26.188-21.967c-1.308-1.349-4.648-18.011-6.303-17.123-2.986 1.603-2.55 7.597-2.55 7.597s-11.437-14.512-13.982-14.699c-2.545-.189.816 4.589.816 4.589s-3.542-3.081-3.723-1.724c-.179 1.357 3.166 8.171 7.372 13.293 0 0-8.921-10.419-10.114-9.748-1.193.671 1.995 5.785 1.995 5.785s-3.378-2.231-2.546-.018c.833 2.213 15.121 21.328 15.121 21.328z"
            fill="#E87C76"
          />
          <Path
            d="M318.604 118.802c-10.272-1.635-29.248 49.139-34.391 56.025l-19.419-16.287c-4.096 5.903-10.872 13.567-14.522 19.771 20.335 26.132 41.438 32.468 41.438 32.468 19.786-16.106 34.416-59.475 34.416-59.475s13.557-26.151-7.522-32.502z"
            fill="#7EADEB"
          />
          <Path
            d="M350.174 119.286s1.966-13.566-1.44-12.232c-4.148 1.625-23.136.026-25.462.155-1.699.093-1.621 7.776-2.967 11.012-.805 1.938-3.027 1.159-3.027 1.159.424 1.136-14.828 33.702-17.097 44.602-2.144 10.298 6.212 36.787 6.183 40.833l46.632.259s9.445-17.641 11.312-41.85c-8.84 5.472-2.421-15.558-2.819-35.878-.092-4.688-10.645-6.865-11.315-8.06z"
            fill="#7EADEB"
          />
          <Path
            d="M352.5 199.211s37.797 45.061 18.195 68.418c-19.603 23.357-102.268 11.356-102.268 11.356l44.477 98.39-31.269 11.975s-69.664-114.842-57.764-135.544c8.469-14.733 85.242-38.698 85.242-38.698l-.343-14.917 43.73-.98z"
            fill="#1E2046"
          />
          <Path
            d="M339.96 199.063c-.01 1.355 22.747 41.29 5.523 48.396-17.224 7.105-94.745 4.174-102.263 17.786-8.701 15.754 51.569 117.421 51.569 117.421"
            stroke="#fff"
            strokeWidth={0.3328}
            strokeMiterlimit={10}
          />
          <Path
            d="M349.944 115.976l-4.594 3.852a33.225 33.225 0 00-12.096 21.955l-11.443 96.461s34.898 32.845 57.909 19.772c23.011-13.073 21.791-20.466 21.791-20.466l-35.836-114.076-15.731-7.498zM320.411 115.505l2.329 5.37a30.811 30.811 0 012.257 16.456l-15.01 81.219-34.92 5.093 45.344-108.138z"
            fill="#FF616B"
          />
          <Path
            d="M307.519 216.384c.479 2.585 27.297-4.076 27.297-4.076 52.167 7.993 62.107-9.683 62.107-9.683-5.736-22.288-18.533-59.583-18.533-59.583s-7.208-30.59-24.881-17.465c-7.442 7.268 14.521 58.469 16.976 66.706l-37.237 6.045c-1.864.245-17.227-7.018-17.501-5.157-.495 3.353 7.794 7.3 7.794 7.3.381 1.969-13.471 1.758-17.753 7.056 0 0-2.745 1.813 11.975-1.51 0 0-12.681 3.671-12.668 5.588.003.479 1.291.502.873.744-1.878 1.087-.284 2.638 3.425 1.776-.955.545-1.874 2.259-1.874 2.259z"
            fill="#E87C76"
          />
          <Path
            d="M378.391 143.041s-7.208-30.589-24.881-17.463c-7.442 7.268 9.49 55.01 11.945 63.247l-20.924 6.298c2.006 6.033 4.419 17.729 6.277 23.81 36.298 1.781 46.115-16.307 46.115-16.307-5.736-22.29-18.532-59.585-18.532-59.585z"
            fill="#7EADEB"
          />
          <Path
            d="M305.735 207.912c2.458-.498 4.868-.889 7.267-1.402 2.406-.483 4.772-1.084 7.227-1.601-2.167 1.272-4.571 2.078-7.02 2.6-2.453.491-4.98.707-7.474.403z"
            fill="#B5504A"
          />
        </G>
      </G>
      <G clipPath="url(#clip1_1_1838)">
        <Mask
          id="b"
          style={{
            maskType: "alpha",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={80}
          width={194}
          height={174}
        >
          <Path
            d="M118.086 253.563h-.001c-7.314 0-14.477-.27-22.769-.583-7.123-.269-15.197-.575-24.81-.755-28.08-.53-41.242-2.552-58.581-20.732-16.226-17.011-12.56-61.459-8.244-80.319 9.837-42.971 36.178-66.65 78.292-70.378a93.737 93.737 0 018.217-.36c27.854 0 55.828 12.214 74.833 32.673 14.598 15.715 31.294 44.028 27.926 89.672-3.457 46.848-35.315 48.832-56.396 50.146l-1.73.11a257.09 257.09 0 01-16.737.526z"
            fill="#000"
          />
        </Mask>
        <G mask="url(#b)">
          <Path
            d="M143.719 146.609s-15.199 50.886-23.819 48.274l-23.46-18.565 9.436-17.741 14.459 10.943c.314.508 14.064-29.005 14.064-29.005s-1.29-14.142.538-15.056c1.792-.897 1.433 7.707 2.509 8.245 1.076.538 5.019-19.358 7.169-18.282 1.156.579-2.688 12.009-1.434 12.905.653.467 6.501-9.307 7.528-9.499 2.869-.538-6.273 11.292-5.377 11.292.897 0 6.99-10.037 8.066-8.245.665 1.108-5.557 9.321-5.019 10.037.538.717 3.585-4.659 5.377-4.839 1.793-.179-3.942 7.528-4.122 8.424-.179.896-2.509 7.169-5.915 11.112z"
            fill="#FF937E"
          />
          <Path
            d="M138.841 135.174s2.516-.503 2.516 3.65M148.38 131.912s-4.254-3.029-7.273-3.658"
            stroke="#E36F59"
            strokeWidth={0.5297}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <Path
            d="M78.712 135.1s14.54 9.034 19.5 14.096c2.22 2.266 6.988 6.277 11.577 10.019-1.492 8.279-3.634 16.545-5.215 24.588l-.151.77c-16.444-12.998-37.383-33.962-25.71-49.473z"
            fill="#3F468E"
          />
          <Path
            d="M101.159 114.665c1.083-2.148-1.296-11.449-3.963-14.783-4.579-5.723-13.033-8.272-21.766-4.714 0 0-7.349 2.33-10.216 6.812-1.815 2.836-2.33 6.811-3.942 9.32-1.614 2.509-5.917 2.37-4.842 6.134 1.075 3.764 4.934 4.908 1.888 8.493-3.048 3.585-7.2 3.248-7.738 7.55l29.442.188"
            fill="#FF616B"
          />
          <Path
            d="M63.494 109.87a8.51 8.51 0 110-17.02 8.51 8.51 0 010 17.02z"
            fill="#FF616B"
          />
          <Path
            d="M83.103 110.513c-1.243-1.07-5.577 5.03-6.724 3.858a.248.248 0 00-.08-.06c-1.25-.454-4.046-1.753-5.626 1.379-1.677 3.326 1.162 6.463 3.038 7.041.909.28 2.015 1.264 2.4 2.133 2.065 4.665-.897 14.004-1.22 17.623-.728 8.169-7.356-.79-7.356-.79s22.106 17.386 25.37 7.67c-2.668-4.668-4.33-19.366-1.988-18.49 3.073 1.15 9.535-2.721 10.321-16.709-1.314-3.811-2.749-6.441-4.041-8.285-1.31-1.87-2.562-3.909-3.4-1.785-1.576 3.985-5.283 11.071-10.694 6.415z"
            fill="#FF937E"
          />
          <Path
            d="M71.758 117.148s3.452-3.45 3.962 3.007l-3.962-3.007z"
            fill="#E36F59"
          />
          <Path
            d="M87.901 117.857a3.125 3.125 0 11-1.97 5.93 3.125 3.125 0 011.97-5.93zM99.452 123.458a3.126 3.126 0 01-1.403-3.69c.366-1.105 1.667-1.68 2.732-1.893 0 0-.282 3.516-1.329 5.583z"
            fill="#FF8169"
          />
          <Path
            d="M95.685 116.302l-.557 3.602 1.804-.132c.334-.025.519-.396.212-.928l-1.459-2.542z"
            fill="#E36F59"
          />
          <Path
            d="M90.614 111.872c-.583.405.32-1.412 1.115-1.62.796-.207 1.586.18 1.765.867 0 0-1.48-.219-2.88.753zM99.838 113.014c.578.41-.305-1.416-1.098-1.631-.793-.216-1.587.164-1.774.85 0 0 1.481-.206 2.872.781zM91.981 116.472c.025.614.286 1.1.584 1.089.297-.012.519-.52.494-1.133-.025-.614-.286-1.101-.584-1.088-.298.011-.518.518-.494 1.132zM96.842 115.977c.024.586.273 1.051.557 1.041.284-.012.495-.496.472-1.082-.024-.587-.273-1.052-.557-1.04-.284.012-.495.496-.472 1.081z"
            fill="#000"
          />
          <Path
            d="M90.66 130.841s-4.332-1.532-7.088-2.722c-2.757-1.191 4.069 10.161 7.087 2.722z"
            fill="#1E2046"
          />
          <Path
            d="M97.887 120.705l-5.6-.125s1.724 3.702 3.335 3.334c2.203-.503 2.265-3.209 2.265-3.209z"
            fill="#FEF2FB"
          />
          <Path
            d="M63.063 194.107c-5.887 10.408-13.615 21.526-16.999 34.758C42.141 244.21-1.359 374.596-3.21 402.508c4.836 1.165 33.15.412 36.205.242 9.721-27.858 39.1-129.887 43.268-147.436.64-2.698 4.808-2.106 4.484.648-2.366 20.04-12.699 94.023-12.699 148.987 2.536 1.291 29.92.368 32.849 0 3.186-34.372 20.815-166.013-4.705-208.194-11.672-1.607-21.296-3.001-33.13-2.648z"
            fill="#5BC29C"
          />
          <Path
            opacity={0.5}
            d="M45.752 230.025c.12-.431.229-.83.312-1.158 3.384-13.232 11.112-24.351 16.998-34.759 11.817-.352 21.433 1.038 33.08 2.644-16.7 11.236-33.552 22.244-50.39 33.273z"
            fill="#5BC29C"
          />
          <Path
            d="M93.174 198.409s11.888 28.641 11.888 64.948c0 36.307-8.905 141.892-8.905 141.892M5.85 402.509L64.2 200.143"
            stroke="#fff"
            strokeWidth={0.4246}
            strokeMiterlimit={10}
          />
          <Path
            d="M90.46 140.474c1.145.916 12.364 27.533 11.961 35.613-.409 8.14-4.407 23.667-4.407 23.667s-4.947 4.949-39.791-.538c-8.604-18.551-6.99-46.781 4.48-58.342 0 0 8.54-1.925 12.504-3.247 0 0 7.112 8.177 11.418 8.115 1.958-.026 4.058-2.378 3.835-5.268z"
            fill="#3F468E"
          />
          <G opacity={0.5} fill="#3F468E">
            <Path d="M71.767 138.641c6.09 4.417 9.172 15.038 11.082 21.713 2.56 8.951 3.676 18.168 4.518 27.414.658 7.226 12.013 7.271 11.35 0-1.052-11.552-2.4-23.236-6.117-34.279-.982-2.914-2.098-6.03-3.444-9.089a5.326 5.326 0 001.304-3.926c1.145.916 12.364 27.533 11.961 35.613-.409 8.14-4.407 23.667-4.407 23.667s-.991.98-5.16 1.584c-10.419-19.82-20.86-39.682-28.04-60.953a226.848 226.848 0 006.953-1.744zM56.512 150.795c6.57 17.548 15.036 34.271 23.716 50.873-5.52-.269-12.685-.984-22.005-2.452-6.687-14.417-7.2-34.678-1.711-48.421z" />
          </G>
          <Path
            d="M70.324 163.841c9.611-.514 19.2-1.264 28.74-2.485 1.998 5.966 3.509 11.675 3.357 14.731-.409 8.14-2.962 28.54-2.962 28.54s-11.954 2.279-34.349 0c5.284-15.853 7.58-28.495 5.214-40.786z"
            fill="#5BC29C"
          />
          <Path
            opacity={0.5}
            d="M96.013 169.679c-1.6-.286-2.328-.9-3.034-2.349-.743-1.528-1.132-3.294-1.39-5.113 2.495-.258 4.987-.542 7.475-.861a114.477 114.477 0 012.008 6.584c-1.587 1.037-2.704 2.162-5.06 1.739zM76.778 163.444c1.403 2.72 1.933 5.523-.711 7.169-.3.062-.597.109-.89.126-1.812.106-3.063-.991-4.184-2.287a50.971 50.971 0 00-.67-4.61c2.154-.115 4.305-.252 6.455-.398z"
            fill="#5BC29C"
          />
          <Path
            d="M90.4 208.906s-55.414 2.446-55.26-6.561l6.567-30.557 21.857.685-4.374 17.884c-.403.44 39.241 10.512 39.241 10.512s13.499 16.117 13.255 16.082c0 0 1.362 2.273-.148 1.895-1.51-.378-9.563-8.43-9.563-8.43s7.55 9.185 6.04 9.436c-1.51.251-3.019-1.51-3.019-1.51s1.888 1.761.88 1.888c-1.007.125-3.9-2.517-3.9-2.517s.629 2.013.126 2.139c-.503.126-11.701-10.946-11.701-10.946z"
            fill="#FF937E"
          />
          <Path
            d="M63.393 175.266c-8.305-.315-16.604-.702-24.906-1.077 2.989-16.189 10.61-39.351 29.427-32.098 0 0 5.48 7.555 1.97 13.71-1.76 3.085-4.347 11.667-6.491 19.465z"
            fill="#3F468E"
          />
          <Path
            d="M105.699 219.033s-5.122-5.298-6.064-6.888M102.343 218.032s-3.532-4.121-4.238-4.769"
            stroke="#E36F59"
            strokeWidth={0.4957}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <Path
            d="M98.12 200.617s12.826 5.889 11.395 6.808c-1.066.686-5.696.045-5.696.045l-5.7-6.853z"
            fill="#FF937E"
          />
          <Path
            d="M93.169 143.478s3.863 4.173 6.787 22.918a3.332 3.332 0 01-3.105 3.832 3.32 3.32 0 01-3.486-2.937c-.562-4.966-1.706-19.848-2.965-27.02 1.258.88 2.769 3.207 2.769 3.207z"
            fill="#5BC29C"
          />
          <Path
            d="M94.584 165.686a2.139 2.139 0 114.277 0 2.139 2.139 0 01-4.277 0z"
            fill="#FFF8ED"
          />
          <Path
            d="M64.072 140.271l6.04-1.321s6.034 8.702 8.958 27.447a3.332 3.332 0 01-3.105 3.831 3.32 3.32 0 01-3.487-2.937c-.748-6.621-3.045-21.27-8.406-27.02z"
            fill="#5BC29C"
          />
          <Path
            d="M73.896 166.5a2.138 2.138 0 114.277 0 2.138 2.138 0 01-4.277 0z"
            fill="#FFF8ED"
          />
        </G>
      </G>
      <G clipPath="url(#clip2_1_1838)">
        <Mask
          id="c"
          style={{
            maskType: "alpha",
          }}
          maskUnits="userSpaceOnUse"
          x={114}
          y={173}
          width={270}
          height={189}
        >
          <Path
            d="M234.87 361.956h-.013c-31.007 0-57.914-2.33-75.764-6.557-20.316-4.812-33.848-13.154-40.219-24.795-5.384-9.837-5.632-21.919-.736-35.911.185-.526.374-1.074.571-1.645 3.823-11.079 10.939-31.702 44.793-72.791 24.615-29.875 56.206-46.328 88.954-46.328 12.082 0 24.094 2.225 35.7 6.614 28.932 10.942 53.127 28.532 69.968 50.867 14.172 18.798 23.006 40.776 24.874 61.888 2.018 22.81-4.471 41.601-16.934 49.039-22.711 13.552-82.255 19.619-131.194 19.619z"
            fill="#000"
          />
        </Mask>
        <G mask="url(#c)">
          <Path
            d="M262.181 352.308s4.995 59.746 5.465 76.254c.469 16.508-2.844 90.1-2.844 90.1l-16.022.059s-19.27-123.153-39.451-162.965l52.852-3.448z"
            fill="#1E2046"
          />
          <Path
            d="M236.982 355.461s14.213 69.022 14.213 79.62c0 1.703 1.901 57.251 1.991 61.608"
            stroke="#fff"
            strokeWidth={0.5233}
            strokeMiterlimit={10}
          />
          <Path
            d="M254.76 351.902s-4.085 50.21-15.816 85.444c-9.478 28.474-37.693 81.69-37.693 81.69l-16.081.729 20.235-81.573a70.802 70.802 0 002.032-12.976c1.041-16.546-2.361-49.98-3.782-71.403l51.105-1.911z"
            fill="#45A2B9"
          />
          <Path
            d="M221.758 353.235s5.457 64.556.552 74.596"
            stroke="#fff"
            strokeWidth={0.5233}
            strokeMiterlimit={10}
          />
          <Path
            d="M323.237 250.249l-.962 2.978s-7.882 16.898-11.174 25.81l-6.603-27.101s3.084-5.001 4.846-8.373c0 0-3.296-16.749-2.69-18.019 1.083-2.274 4.882 8.281 5.414 7.107 1.495-3.298 2.32-5.642 2.708-6.092 0 0 2.707-16.921 4.399-14.89 1.692 2.03.677 14.213.677 14.213s6.768-12.521 9.137-12.183c2.369.338.338 5.414.338 5.414s2.03-4.738 3.046-3.046c1.016 1.692-1.354 7.445-1.354 7.445s5.076-2.707 5.076-.676c.001 2.032-12.858 27.413-12.858 27.413z"
            fill="#FF937E"
          />
          <Path
            d="M329.328 219.115l-4.964 9.475M331.02 223.514l-3.723 6.881M317.821 225.432c.451.676 12.634 6.317 12.634 6.317M313.76 235.133s4.062 4.963 3.384 8.573"
            stroke="#D4635F"
            strokeWidth={0.966}
            strokeMiterlimit={10}
          />
          <Path
            d="M291.749 273.461s-56.289-37.554-62.483-11.513c-3.181 13.372 54.178 38.143 71.607 41.812 2.028.427 4.059-.712 4.792-2.651l16.767-48.355-13.969-7.505-16.714 28.212z"
            fill="#FF937E"
          />
          <Path
            d="M291.749 273.461s-54.193-44.438-60.387-18.398c-3.18 13.372 33.309 52.233 70.085 49.311 2.066-.164 4.059-.712 4.792-2.65l16.192-48.97-19.049-9.951-11.633 30.658z"
            fill="#3A6FB1"
          />
          <Path
            d="M271.977 279.416c-7.242-12.687-17.009-23.532-28.505-32.458-5.981-.524-10.556 1.573-12.11 8.105-2.627 11.047 21.428 39.068 50.607 46.833-2.67-7.761-5.901-15.315-9.992-22.48z"
            fill="#3A6FB1"
          />
          <Path
            d="M191.901 273.669c.559-14.068 23.018-26.725 23.018-26.725l7.907-5.583-.063.441 14.054 11.582 4.306-3.713-.233-2.412 4.243 1.435c1.814.226 10.192 9.428 12.919 13.687a31.471 31.471 0 014.917 15.455l8.681 94.736-73.022 2.518s-7.588-79.771-6.727-101.421z"
            fill="#3A6FB1"
          />
          <Path
            d="M218.935 326.872c-5.238-10.441-9.993-21.153-14.605-31.885-4.08-9.491-7.786-19.13-9.97-29.226-1.421 2.53-2.35 5.192-2.459 7.908-.861 21.651 6.727 101.42 6.727 101.42l48.093-1.658c-10.333-14.849-19.665-30.37-27.786-46.559z"
            fill="#3A6FB1"
            opacity={0.53}
          />
          <Path
            d="M224.869 211.67s-1.805-15.567 1.128-16.696c2.933-1.128 15.117-2.482 15.117-2.482s-1.58-6.542 3.158-6.542c4.738 0 4.061 6.542 4.061 6.542s3.384-4.512 5.641-2.933c2.256 1.579 2.482 5.866.451 6.543 0 0 5.414 2.707 2.933 4.963-2.482 2.256-4.287.903-4.287.903s4.061 2.707 1.805 4.286c-2.257 1.58-25.72 15.342-25.72 15.342l-4.287-9.926z"
            fill="#2A3E5E"
            stroke="#2A3E5E"
            strokeWidth={0.2246}
            strokeMiterlimit={10}
          />
          <Path
            opacity={0.76}
            d="M224.099 201.949c-.049 4.586.545 9.721.545 9.721l4.287 9.927s7.198-4.222 14.004-8.259c-5.121-5.879-11.587-10.604-18.836-11.389z"
            fill="#FF937E"
          />
          <Path
            d="M251.474 204.28s2.754 20.18-1.898 29.754c-.611 1.257-1.867 2.069-3.261 2.177-2.369.183-4.699-.052-5.872-.201 2.023.25 1.37 5.422 3.376 12.208 0 0-.677 6.091-11.008 4.676-3.417-.467-12.229-9.188-12.229-9.188s4.402-12.74 4.7-16.735c.159-2.134.207-4.228.025-5.345-2.515-.22-3.253-4.875-2.303-7.399.905-2.408 5.514-2.231 6.379-.079.275.684 1.068 1.402 1.929.376.737-.878.86-8.491 2.815-9.517 6.63 1.048 12.828.583 14.966 0 2.001-.543 2.381-.727 2.381-.727z"
            fill="#FF937E"
          />
          <Path
            d="M223.631 216.233c1.167-4.568 4.277-.971 4.277-.971l-4.277.971z"
            fill="#D4635F"
          />
          <Path
            d="M241.901 236.205l-5.976-.874.53 1.59c.973 2.919 5.26 2.356 5.446-.716z"
            fill="#1E2046"
          />
          <Path
            d="M245.946 217.267s2.231 6.622 1.967 6.61c-.692-.03-2.282-.079-2.282-.079l.315-6.531z"
            fill="#D4635F"
          />
          <Path
            d="M247.48 218.928c.01.676.282 1.221.608 1.217.327-.004.584-.556.575-1.234-.009-.676-.281-1.222-.608-1.217-.327.005-.584.558-.575 1.234zM242.13 219.085c.009.676.281 1.222.608 1.217.326-.005.583-.557.575-1.234-.01-.676-.282-1.222-.608-1.217-.328.005-.585.557-.575 1.234z"
            fill="#020F2B"
          />
          <Path
            d="M238.988 214.58c-.779.108.122-1.664 3.249-2.282 1.102-.218 1.888.96 1.396 1.819-.32.561-1.827.075-4.645.463zM250.904 212.86c.753.227.16-2.052-2.075-2.733-1.558-.474-1.944.875-1.36 1.847.299.498 2.249.529 3.435.886z"
            fill="#1E2046"
          />
          <Path
            d="M249.645 225.136l-8.104-.315s1.791 3.38 4.123 3.478c1.876.077 3.981-3.163 3.981-3.163z"
            fill="#fff"
          />
          <Path
            d="M178.877 334.352c8.854 4.135 24.217 16.51 24.217 16.51s26.519 11.237 27.598 10.088c1.079-1.148-6.486-6.598-6.486-6.598 1.533-.107 9.643 4.191 10.275 3.479.633-.714-9.22-6.423-9.05-7.02.171-.597 10.372 5.394 11.119 4.284.747-1.111-9.456-7.103-9.487-7.742-.033-.638 10.689 5.038 10.941 3.404.252-1.634-16.739-8.281-17.136-9.522-.397-1.24 7.722-.733 10.246-2.427 2.523-1.694-15.8-2.927-15.8-2.927-3.479-1.09-25.219-18.64-25.219-18.64l-11.218 17.111z"
            fill="#FF937E"
          />
          <Path
            d="M206.624 352.339c.77-6.861 1.548-13.721 2.224-20.591-7.607-5.51-18.75-14.506-18.75-14.506l-11.221 17.11c8.854 4.135 24.217 16.509 24.217 16.509s1.388.588 3.53 1.478z"
            fill="#1E2046"
          />
          <Path
            d="M187.91 311.207s43.697-35.567 25.568-58.202c-9.703-12.115-66.71 51.138-68.016 61.853l54.43 34.727 15.821-18.427-27.803-19.951z"
            fill="#3A6FB1"
          />
          <Mask
            id="d"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={145}
            y={241}
            width={178}
            height={135}
          >
            <Path
              d="M303.383 243.256l-11.634 30.206s-46.758-38.337-58.368-22.909l-10.617-8.75.063-.44-7.908 5.582s-3.232 1.823-7.271 4.85c-17.544 4.419-61.047 53.719-62.185 63.065l50.683 32.336a2958.518 2958.518 0 002.483 27.896l73.022-2.518-7.116-77.657c11.134 6.36 24.004 10.486 36.912 9.46 2.066-.165 4.058-.713 4.792-2.651l16.191-48.969-19.047-9.501zM187.91 311.207s2.087-1.699 5.159-4.589c.183 2.854.38 5.769.586 8.711l-5.745-4.122z"
              fill="#fff"
            />
          </Mask>
          <G mask="url(#d)" fill="#fff">
            <Path d="M124.762 312.808c9.505-18.725 22.749-35.467 38.72-49.097a157.628 157.628 0 0125.85-17.946c4.219-2.339 11.825-6.355 14.587.085 1.079 2.513 1.181 5.476 1.544 8.153.447 3.29.892 6.581 1.338 9.872l5.917 43.646c.023.168.216.275.368.28 6.511.225 11.991-3.859 16.95-7.573 4.861-3.641 10.483-8.379 16.977-7.8 9.506.847 13.968 11.896 16.879 19.545 3.309 8.696 5.693 17.955 10.856 25.807 4.808 7.312 12.066 13.617 21.129 14.252.49.035.488-.729 0-.763-8.777-.614-15.819-6.806-20.47-13.874-5.306-8.063-7.653-17.603-11.119-26.505-2.799-7.19-6.804-16.694-15.091-18.852-6.095-1.586-11.704 1.788-16.456 5.234-5.815 4.217-11.976 10.031-19.656 9.767l.368.28-5.53-40.789-1.374-10.131c-.41-3.026-.616-6.175-1.364-9.141-.544-2.153-1.655-4.192-3.766-5.136-2.151-.962-4.646-.524-6.79.227-2.384.835-4.59 2.135-6.781 3.373a156.553 156.553 0 00-7.178 4.315 160.807 160.807 0 00-36.447 31.992 159.462 159.462 0 00-20.122 30.396c-.219.434.439.821.661.383z" />
            <Path d="M200.857 228.974a232.69 232.69 0 0014.95 24.285 232.698 232.698 0 008.334 11.111c2.904 3.642 5.85 7.353 9.115 10.684 13.495 13.768 30.653-6.776 37.277-17.801 5.03-8.37 8.553-17.559 11.337-26.891.141-.472-.595-.673-.736-.204-4.647 15.572-11.66 32.096-24.474 42.744-3.106 2.58-6.785 4.765-10.777 5.582-4.316.883-8.286-.33-11.466-3.355-3.122-2.969-5.836-6.477-8.545-9.817a229.454 229.454 0 01-8.443-11.081 232.68 232.68 0 01-15.915-25.643c-.23-.432-.889-.048-.657.386zM281.047 255.968a2216.365 2216.365 0 0037.918 75.97c.228.435.887.051.66-.386a2214.84 2214.84 0 01-37.918-75.97c-.212-.442-.87-.056-.66.386zM287.901 252.1a3076.39 3076.39 0 0146.425 76.707c.247.423.908.04.659-.386a3072.53 3072.53 0 00-46.426-76.708c-.259-.414-.919-.031-.658.387zM135.416 311.851a313.27 313.27 0 0049.752-1.95c.481-.058.487-.822 0-.764a313.148 313.148 0 01-49.752 1.95c-.491-.02-.49.744 0 .764zM151.402 286.557l30.44 18.302c.423.254.806-.406.386-.659-10.147-6.102-20.294-12.201-30.441-18.302-.422-.253-.807.406-.385.659z" />
          </G>
        </G>
      </G>
      <Path
        d="M405.546 278.058c-.172 0-.349-.018-.529-.054-.984-.164-1.749-.797-2.143-1.782-.481-1.2-.309-2.714.418-3.682.562-1.135 2.013-2.327 3.573-3.019-.318-.407-.705-.723-1.163-.906-1.053-.422-2.96-.504-4.419.172-.759.352-1.25.848-1.458 1.472a.374.374 0 11-.711-.237c.272-.817.913-1.479 1.855-1.916 1.447-.671 3.603-.753 5.011-.188.657.263 1.193.727 1.609 1.32a6.87 6.87 0 01.802-.215c1.593-.533 2.968-.501 4.042.107 1.156.653 1.961 1.975 2.395 3.927a.375.375 0 11-.733.162c-.386-1.736-1.069-2.892-2.031-3.437-.885-.501-2.055-.512-3.481-.036-.2.04-.401.092-.604.155.78 1.577.906 3.714.39 5.452-.514 1.73-1.548 2.704-2.823 2.705zm1.726-7.895c-1.454.624-2.824 1.725-3.346 2.768-.604.815-.739 2.058-.358 3.012.208.518.651 1.168 1.583 1.324 1.599.314 2.276-1.382 2.498-2.127.476-1.6.341-3.583-.377-4.977zM94.342 299.712c-1.839 0-3.552-.729-4.858-2.076-.58-.654-1.018-1.522-1.282-2.462a5.622 5.622 0 01-2.724-.987c-1.434-.992-2.402-2.617-2.655-4.455-.285-2.279.5-3.681 1.731-5.561a.375.375 0 01.628.411c-1.17 1.786-1.874 2.985-1.616 5.051.224 1.627 1.077 3.064 2.338 3.937a4.882 4.882 0 002.122.83c-.158-.909-.155-1.846.036-2.694.36-1.602 1.311-2.773 2.749-3.386.87-.371 1.787-.272 2.454.264.766.614 1.09 1.695.867 2.888-.384 1.57-2.157 3.097-4.128 3.576a5.944 5.944 0 01-1.025.141c.236.742.595 1.42 1.054 1.939a5.98 5.98 0 004.626 1.827 6.406 6.406 0 004.701-2.425.376.376 0 01.528-.063c.161.129.189.364.062.527a7.155 7.155 0 01-5.608 2.718zm-2.48-10.865c-.243 0-.5.054-.757.164-1.525.65-2.099 1.914-2.313 2.86-.182.812-.173 1.714-.002 2.575a5.061 5.061 0 001.044-.128c1.686-.408 3.254-1.728 3.566-3.003.168-.897-.056-1.707-.603-2.146a1.475 1.475 0 00-.934-.322zM97.387 84.898a.375.375 0 01-.375-.373c-.014-3.199 1.221-6.402 3.223-8.36 1.415-1.382 3.178-2.12 5.114-2.139 1.517-2.38 4.685-3.846 7.466-3.385 1.631.27 3.059 1.163 4.44 2.026 2.553 1.595 4.759 2.973 7.596-.02a.374.374 0 01.53-.014c.151.142.157.38.014.53-3.257 3.438-5.941 1.762-8.537.14-1.318-.825-2.682-1.676-4.165-1.922-2.318-.383-5.02.786-6.457 2.685 2.994.297 4.522 2.188 4.956 3.937.405 1.63-.077 3.249-1.144 3.85-.616.349-1.936.646-3.846-1.27-1.705-1.713-2.158-3.807-1.267-5.79-1.585.107-2.987.748-4.174 1.91-1.862 1.82-3.01 4.817-2.998 7.82a.375.375 0 01-.373.376h-.003zm8.386-10.114l-.04.077c-.918 1.78-.563 3.623.999 5.192 1.139 1.143 2.214 1.561 2.947 1.147.767-.432 1.105-1.73.785-3.016-.189-.764-1.084-3.237-4.691-3.4z"
        fill="#000"
      />
      <Path
        d="M405.511 189.97c-2.625 0-4.667-1.619-5.2-4.125-.483-2.268.258-3.784.963-4.657 1.015-1.254 2.65-2.003 4.373-2.003 2.405 0 4.424 1.379 5.401 3.687.436 1.066.368 2.344-.189 3.604-.637 1.439-1.836 2.625-3.129 3.095a6.475 6.475 0 01-2.219.399zm.136-10.036c-1.499 0-2.916.645-3.791 1.725-.865 1.069-1.146 2.463-.812 4.029.456 2.146 2.21 3.532 4.467 3.532.656 0 1.317-.119 1.963-.354 1.107-.403 2.142-1.435 2.699-2.695.475-1.071.539-2.14.182-3.012-.853-2.017-2.614-3.225-4.708-3.225z"
        fill="#F7941D"
      />
      <Path
        d="M30.33 292.418c-2.625 0-4.667-1.62-5.201-4.127-.484-2.267.257-3.784.964-4.656 1.015-1.255 2.65-2.004 4.372-2.004 2.405 0 4.424 1.378 5.401 3.687.437 1.068.37 2.346-.189 3.606-.637 1.439-1.835 2.624-3.128 3.094-.729.265-1.475.4-2.22.4zm.135-10.038c-1.499 0-2.916.645-3.79 1.726-.865 1.07-1.146 2.463-.812 4.028.456 2.147 2.21 3.534 4.468 3.534.655 0 1.316-.119 1.962-.354 1.107-.403 2.142-1.435 2.7-2.694.474-1.072.538-2.141.181-3.014-.854-2.017-2.615-3.226-4.709-3.226zM397.287 240.633a4.211 4.211 0 01-3.488-1.838l-7.513-11.062a4.174 4.174 0 01-.646-3.151 4.175 4.175 0 011.762-2.69l11.063-7.515a4.173 4.173 0 012.352-.721 4.21 4.21 0 013.49 1.839l7.514 11.061c1.3 1.919.8 4.54-1.117 5.842l-11.06 7.512a4.186 4.186 0 01-2.357.723zm3.529-26.228c-.693 0-1.361.205-1.93.593l-11.063 7.514a3.43 3.43 0 00-1.448 2.211 3.428 3.428 0 00.531 2.588l7.513 11.062a3.457 3.457 0 002.868 1.51c.693 0 1.361-.204 1.933-.593l11.06-7.512a3.464 3.464 0 00.918-4.802l-7.513-11.059a3.462 3.462 0 00-2.869-1.512z"
        fill="#3A6FB1"
      />
      <Path
        d="M67.661 338.002c-1.536 0-2.663-1.222-2.942-3.187l-2.174-15.358c-.183-1.291.056-2.359.691-3.089.847-.977 2.314-1.181 3.93-.53l14.386 5.794c1.418.571 2.287 1.501 2.445 2.618.158 1.117-.417 2.252-1.62 3.194l-12.213 9.563c-.83.649-1.696.995-2.503.995zm-2.288-21.797c-.657 0-1.2.226-1.572.653-.48.554-.664 1.44-.514 2.493l2.174 15.357c.226 1.592 1.048 2.544 2.2 2.544.637 0 1.343-.29 2.04-.836l12.213-9.563c.982-.77 1.459-1.658 1.34-2.499-.12-.841-.823-1.561-1.983-2.028l-14.386-5.794c-.539-.216-1.047-.327-1.512-.327z"
        fill="#F7941D"
      />
      <Path
        d="M184.21 81.428c-.676 0-1.397-.208-2.142-.618l-13.591-7.473c-1.34-.736-2.09-1.763-2.114-2.892-.023-1.128.684-2.185 1.991-2.976l13.269-8.033c.778-.47 1.534-.71 2.249-.71 1.713 0 2.85 1.388 2.894 3.538l.324 15.505c.025 1.226-.3 2.22-.942 2.875-.503.513-1.172.784-1.938.784zm-.339-21.952c-.568 0-1.211.207-1.861.6l-13.269 8.034c-1.069.647-1.647 1.47-1.629 2.32.018.85.63 1.648 1.725 2.25l13.592 7.474c1.278.702 2.473.69 3.182-.035.498-.508.749-1.315.728-2.335l-.324-15.506c-.036-1.728-.857-2.802-2.144-2.802z"
        fill="#EC008D"
      />
      <Path
        d="M234.87 361.956h-.013c-31.007 0-57.914-2.33-75.764-6.557-20.316-4.812-33.848-13.154-40.219-24.795-5.384-9.837-5.632-21.919-.736-35.911.185-.526.374-1.074.571-1.645 3.823-11.079 10.939-31.702 44.793-72.791 24.615-29.875 56.206-46.328 88.954-46.328 12.082 0 24.094 2.225 35.7 6.614 28.932 10.942 53.127 28.532 69.968 50.867 14.172 18.798 23.006 40.776 24.874 61.888 2.018 22.81-4.471 41.601-16.934 49.039-22.711 13.552-82.255 19.619-131.194 19.619zm17.586-187.278c-32.52 0-63.906 16.356-88.376 46.056-33.768 40.985-40.856 61.523-44.664 72.559-.198.572-.387 1.121-.571 1.647-4.824 13.784-4.593 25.662.686 35.305 6.265 11.447 19.633 19.663 39.734 24.425 17.796 4.214 44.642 6.537 75.592 6.537h.013c48.837 0 108.22-6.033 130.81-19.514 12.214-7.29 18.564-25.808 16.571-48.329-3.228-36.481-29.877-87.733-94.361-112.12-11.521-4.358-23.442-6.566-35.434-6.566z"
        fill="#000"
      />
      <Path
        d="M334.456 206.655h-.008c-26.456 0-52.708-5.255-67.148-9.754-34.168-10.646-51.645-38.791-53.428-86.043-.828-21.962 6.664-38.925 22.272-50.418 12.918-9.514 29.148-13.852 43.318-16.839 15.717-3.313 30.18-4.993 42.985-4.993 23.091 0 41.576 5.45 54.944 16.198 10.999 8.844 16.687 19.756 20.413 28.275 4.745 10.85 7.904 28.189 8.242 45.255.296 14.874-1.344 36.561-10.828 55.413-9.523 18.93-38.298 22.906-60.762 22.906zm-12.01-167.298c-12.753 0-27.163 1.675-42.83 4.977-33.118 6.982-66.738 20.342-64.995 66.495 1.77 46.897 19.074 74.817 52.901 85.356 15.528 4.838 42.243 9.72 66.925 9.721h.008c22.255 0 50.741-3.903 60.093-22.493 9.415-18.716 11.042-40.274 10.748-55.062-.337-16.974-3.472-34.205-8.18-44.97-5.267-12.04-19.257-44.023-74.67-44.023zM119.156 253.563h-.002c-7.314 0-14.476-.27-22.769-.583-7.122-.269-15.197-.575-24.809-.755-28.081-.53-41.243-2.552-58.582-20.732-16.226-17.011-12.56-61.459-8.243-80.319 9.837-42.971 36.177-66.65 78.291-70.378a93.733 93.733 0 018.218-.36c27.853 0 55.828 12.214 74.833 32.673 14.598 15.715 31.293 44.028 27.925 89.672-3.457 46.848-35.314 48.832-56.396 50.146l-1.73.11c-5.617.358-10.935.526-16.736.526zM91.259 81.185c-2.733 0-5.475.12-8.151.357-41.754 3.697-67.872 27.181-77.628 69.798-4.288 18.732-7.962 62.844 8.055 79.635C30.68 248.949 43.73 250.95 71.59 251.474c9.62.182 17.697.486 24.824.756 8.286.313 15.441.582 22.74.582h.002c5.785 0 11.088-.167 16.689-.525l1.731-.109c20.821-1.297 52.286-3.257 55.695-49.453 2.649-35.916-6.939-66.728-27.728-89.107-18.865-20.309-46.635-32.433-74.282-32.433z"
        fill="#000"
      />
      <Path
        d="M265.821 51.477h29.416l14.708 25.738V25.738C309.945 11.524 298.42 0 284.206 0h-18.385c-14.216 0-25.738 11.524-25.738 25.738 0 14.215 11.524 25.739 25.738 25.739z"
        fill="#D63C8A"
      />
      <Path
        d="M263.447 27.117a3.64 3.64 0 00-7.278 0 3.64 3.64 0 007.278 0zM277.664 27.117a3.64 3.64 0 00-7.278 0 3.64 3.64 0 007.278 0zM291.981 27.117a3.64 3.64 0 10-7.278 0 3.64 3.64 0 007.278 0z"
        fill="#FFF8ED"
      />
      <Path
        d="M172.362 94.33h-29.493l-14.747 25.807V68.525c0-14.253 11.555-25.806 25.806-25.806h18.434c14.253 0 25.806 11.554 25.806 25.806.001 14.253-11.553 25.806-25.806 25.806z"
        fill="#DD9832"
      />
      <Path
        d="M149.781 75.86a3.649 3.649 0 10-.001-7.297 3.649 3.649 0 00.001 7.297zM164.036 75.86a3.649 3.649 0 100-7.298 3.649 3.649 0 000 7.298zM178.391 75.86a3.648 3.648 0 100-7.296 3.648 3.648 0 000 7.296z"
        fill="#FFF8ED"
      />
      <Defs>
        <ClipPath id="clip0_1_1838">
          <Path
            fill="#fff"
            transform="translate(213.81 38.608)"
            d="M0 0H192.268V168.047H0z"
          />
        </ClipPath>
        <ClipPath id="clip1_1_1838">
          <Path
            fill="#fff"
            transform="translate(0 80.436)"
            d="M0 0H193.387V173.127H0z"
          />
        </ClipPath>
        <ClipPath id="clip2_1_1838">
          <Path
            fill="#fff"
            transform="translate(114.642 173.929)"
            d="M0 0H268.719V188.028H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
